import moment from 'moment-timezone';
import config from '../../config';
import { fetchM } from './fetchM';
import { handleError } from './error';
import {
  ADDRESS_SETTINGS_REQUEST,
  ADDRESS_SETTINGS_SUCCESS,
  ADDRESS_SETTINGS_FAILURE,
} from '../constants/actions';

function addressSettingsRequest() {
  return {
    type: ADDRESS_SETTINGS_REQUEST,
  };
}

function addressSettingsSuccess(data, token = null) {
  return {
    type: ADDRESS_SETTINGS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function addressSettingsError(message) {
  return {
    type: ADDRESS_SETTINGS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchAddressSettings(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(addressSettingsRequest());
    if (!fresh) {
      let addressSettingsData = {};
      try {
        addressSettingsData = JSON.parse(
          localStorage.getItem(`${config.get('appName')}.addressSettings`),
        ) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !addressSettingsData.data ||
        config.get('version') !== addressSettingsData.version
      ) {
        reload = true;
      } else {
        dispatch(fetchM('/address_settings/last_updated/', {
          credentials: 'include',
        }))
          .then((data) => {
            reload = moment(data.lastUpdatedAt).isAfter(moment(addressSettingsData.createdAt));
          })
          .catch(err => dispatch(handleError(err, addressSettingsError)));
      }
      if (!reload) {
        dispatch(addressSettingsSuccess(addressSettingsData.data));
        return Promise.resolve();
      }
    }
    return dispatch(fetchM('/address_settings/', {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          localStorage.setItem(`${config.get('appName')}.addressSettings`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(addressSettingsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, addressSettingsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/addressSettings.js